import { render } from "./StatisticsView.vue?vue&type=template&id=3195cbcf&scoped=true&ts=true"
import script from "./StatisticsView.vue?vue&type=script&lang=ts"
export * from "./StatisticsView.vue?vue&type=script&lang=ts"

import "./StatisticsView.vue?vue&type=style&index=0&id=3195cbcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3195cbcf"]])

export default __exports__